/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function () {
  // Get the video element by its ID
  const videoElement = document.getElementById('UstreamIframe');

  if (videoElement) {
    // Listen for fullscreenchange events
    document.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement && document.fullscreenElement === videoElement) {
        videoElement.style.objectFit = 'contain';
      } else {
        videoElement.style.objectFit = 'cover';
      }
    });

    document.addEventListener('webkitfullscreenchange', () => {
      if (document.webkitFullscreenElement && document.webkitFullscreenElement === videoElement) {
        videoElement.style.objectFit = 'contain';
      } else {
        videoElement.style.objectFit = 'cover';
      }
    });

    document.addEventListener('mozfullscreenchange', () => {
      if (document.mozFullScreenElement && document.mozFullScreenElement === videoElement) {
        videoElement.style.objectFit = 'contain';
      } else {
        videoElement.style.objectFit = 'cover';
      }
    });

    document.addEventListener('msfullscreenchange', () => {
      if (document.msFullscreenElement && document.msFullscreenElement === videoElement) {
        videoElement.style.objectFit = 'contain';
      } else {
        videoElement.style.objectFit = 'cover';
      }
    });
  } else {
    console.error('Video element not found');
  }
})();

